'use client';

import { ForwardedRef, forwardRef, useMemo } from 'react';
import clsx from 'clsx';

import styles from './PriceRange.module.css';

import { Action } from '~/components/FilterBottomSheet/type';
import { FilterSection } from '~/components';
import { convertPricePayloadToNumber } from '~/components/FilterBottomSheet/_utils/payload-utils';

type PriceRangeProps = {
  onChange: (action: Action) => void;
  minPrice: string;
  maxPrice: string;
};

export const PriceRange = forwardRef(function PriceRange(
  { onChange, minPrice, maxPrice }: PriceRangeProps,
  priceRef: ForwardedRef<HTMLDivElement>,
) {
  const isError = useMemo(() => {
    return maxPrice && minPrice && Number(maxPrice) < Number(minPrice);
  }, [maxPrice, minPrice]);

  return (
    <FilterSection title="가격" ref={priceRef}>
      <div className={styles.container}>
        <div className={styles.priceContainer}>
          <input
            type="tel"
            placeholder="최소금액"
            value={minPrice ? Number(minPrice).toLocaleString() : minPrice}
            onChange={(e) => {
              onChange({ type: 'minPrice', payload: convertPricePayloadToNumber(e.target.value) });
            }}
          />
        </div>
        <div className={styles.dash} />
        <div
          className={clsx([styles.priceContainer, isError && styles.error])}
          data-iserror={isError ? 'true' : 'false'}
        >
          <input
            type="tel"
            placeholder="최대금액"
            value={maxPrice ? Number(maxPrice).toLocaleString() : maxPrice}
            onChange={(e) => {
              onChange({ type: 'maxPrice', payload: convertPricePayloadToNumber(e.target.value) });
            }}
            aria-invalid={isError ? 'true' : 'false'}
            aria-errormessage="가격 범위가 올바르지 않습니다."
          />
        </div>
      </div>
    </FilterSection>
  );
});
